import React, { memo, Dispatch, SetStateAction } from 'react';
import { Box } from '@mui/material';
import {
  SortOff as SortOffIcon,
  SortAZ as SortAZIcon,
  SortZA as SortZAIcon,
} from '@x5-react-uikit/icons';

const iconStyle = { marginLeft: '10px', verticalAlign: 'text-bottom' };

const COLORS = ['grey.60', 'accent.70', 'accent.70'];

const ICONS = [
  <SortOffIcon size="small" style={iconStyle} />,
  <SortAZIcon size="small" style={iconStyle} />,
  <SortZAIcon size="small" style={iconStyle} />,
];

type Props = {
  onSortChange?: Dispatch<SetStateAction<{ name: string; direction: number }>>;
  children: React.ReactNode;
  disabled?: boolean;
  filedName: string;
  sort?: { name: string; direction: number };
};

const TableSortControls: React.FC<Props> = ({
  onSortChange = () => {},
  children,
  disabled = false,
  filedName,
  sort: { name, direction } = { name: '', direction: 0 },
}) => {
  if (disabled) return <>{children}</>;

  const current = name === filedName ? direction : 0;

  const getDirection = () => {
    if (filedName !== name) return 1;

    return direction === 2 ? 0 : direction + 1;
  };

  const handleSort = () => {
    onSortChange({ name: filedName, direction: getDirection() });
  };

  return (
    <Box
      onClick={handleSort}
      sx={{ color: COLORS[current], cursor: 'pointer', display: 'inline-flex' }}
    >
      {children}
      {ICONS[current]}
    </Box>
  );
};

export default memo(TableSortControls);
